import BillDateWithTimezone from '@/common/components/BillDateWithTimezone';
import Button from '@/common/components/Button';
import { billingBillStatus } from '@/common/constants/statusBills.constants'
import { formatCurrency } from '@/common/utils/formatters'
import { transformToNumber } from '@/common/utils/transformers'
import { EstablishmentDetails } from '@/features/establishmentBills/components/EstablishmentDetails'
import { EstablishmentBillData } from '@/features/establishmentBills/types/establishmentBills.type'
import { ArrowBigRightIcon } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'

export class EstablishmentBillsTransformer {
  static tableTransformer() {
    return (companyBills: EstablishmentBillData[]) => {
      return companyBills.map((bill) => ({
        status: billingBillStatus.find((option) => option.value === bill.status)?.label || '',
        number: bill.number || '',
        establishment_info: React.createElement(EstablishmentDetails, { establishment: bill.establishment_company }),
        billing: 'Não implementado',
        consumed_total: bill?.consumed_total
          ? formatCurrency(transformToNumber({ value: bill?.consumed_total }) || 0)
          : '',
        fee_total: bill?.fee_total
          ? formatCurrency(transformToNumber({ value: bill?.fee_total, invert: true }) || 0)
          : '',
        total_amount: bill?.total_amount
          ? formatCurrency(transformToNumber({ value: bill?.total_amount }) || 0)
          : '',
        opened_at: bill?.opened_at && (
          <BillDateWithTimezone
            date={bill.opened_at}
            timezone={bill.time_zone}
          />
        ),
        closed_at: bill?.closed_at && (
          <BillDateWithTimezone
            date={bill.closed_at}
            timezone={bill.time_zone}
          />
        ),
        due_at: bill?.due_at && (
          <BillDateWithTimezone
            date={bill.due_at}
            timezone={{
              id: 'america_sao_paulo',
              acronym: 'BRT',
              display_name: 'América - São Paulo',
              identifier: 'America/Sao_Paulo',
              offset: '-03:00',
            }}
            hideTimezone
          />
        ),
        payment_date: 'Não implementado',
        actions: (
          <Link to={`/establishment-bills/${bill.id}`}>
            <Button name="access_establishment_bill_show" variant='link-white' className="w-full" operationKlassToCheckPermission='Admin::Billing::Bills::Show'>
              <ArrowBigRightIcon strokeWidth={1} />
            </Button>
          </Link>
        ),
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (bills: EstablishmentBillData[]) => {
      return bills.map((bill) => ({
        route: `establishment-bills/${bill.id}`,
        items: [
          ['Status', billingBillStatus.find((option) => option.value === bill.status)?.label || ''],
          ['Código', bill.number],
          ['Estabelecimento', bill?.establishment_company?.general_information?.fantasy_name],
        ],
      }));
    };
  }
}
